import { Controller } from 'stimulus';

/**
 * Generic dismissible controller that remembers dismissals in localStorage.
 *
 * @example Basic usage
 *   div[data-controller="dismissible"
 *       data-dismissible-key-value="my_banner"
 *       data-dismissible-dismissed-by-keys-value='["my_banner"]'
 *       data-dismissible-hidden-class-value="my-banner--hidden"]
 *     span Some content
 *     button[data-action="dismissible#dismiss"] Close
 *
 * @example Cascading dismissals (dismissing "live" also suppresses "upcoming")
 *   div[data-dismissible-key-value="contest_42_upcoming"
 *       data-dismissible-dismissed-by-keys-value='["contest_42_upcoming","contest_42_live"]']
 */
export default class extends Controller {
  static values = {
    key: String,
    dismissedByKeys: Array,
    hiddenClass: { type: String, default: 'hidden' },
  };

  connect() {
    if (this.#isDismissed()) {
      this.element.remove();
    } else {
      this.element.classList.remove(this.hiddenClassValue);
      window.dispatchEvent(new Event('resize'));
    }
  }

  dismiss() {
    localStorage.setItem(this.keyValue, '1');
    this.element.classList.add(this.hiddenClassValue);
    this.element.addEventListener('transitionend', () => this.element.remove(), { once: true });
  }

  // private

  #isDismissed() {
    return this.dismissedByKeysValue.some((key) => localStorage.getItem(key));
  }
}
